module.exports = __webpack_public_path__ + "img/safety-bg.7754874b.png";